module.exports = __webpack_public_path__ + "static/media/ELON.e6b23260.png";